import React from 'react';
import {
  Button,
  ButtonGroup,
  DropdownButton,
  Modal,
} from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import * as Fi from 'react-icons/fi';

import { Receivable } from 'services/action';
import { Table } from 'services/action';

import { FormPartial } from './form';

const initialState = {
  isDelete: false,
  isPublish: false,
  isUpdate: false,
};

const Action = ({ data }) => {
  const Dispatch = useDispatch();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services['Receivable.Delete']
  );
  const StateTable = useSelector((state) => state?.Table?.data['receivable']);

  const [{ isDelete, isPublish, isUpdate }, setState] = React.useState(initialState);

  const $handleClose = () => {
    setState((prevState) => ({ ...prevState, isDelete: false, isPublish: false, isUpdate: false }));
  };

  const $handleDelete = async () => {
    const del = await Dispatch(Receivable.$delete(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('receivable', StateTable));
    }
  };

  const $handlePublish = async () => {
    const del = await Dispatch(Receivable.$publish(data?.id));
    if (del?.message === 'success') {
      $handleClose();
      Dispatch(Table.$reload('receivable', StateTable));
    }
  };

  return (
    <>
      <DropdownButton
        as={ButtonGroup}
        variant="transparent"
        size="md"
        className="no-carret tbl-action"
        title={<Fi.FiMoreVertical size={13} color="gray" />}
      >
        <Link
          className="dropdown-item d-flex align-items-center"
          role="button"
          to={`/receivable/${data?.id}`}
        >
          <Fi.FiClipboard size={15} color="#202020" className="me-2" />
          Detil
        </Link>
        {(data?.document_status !== 'new' && data?.customer?.is_send_invoice) && (
          <button
            className="dropdown-item d-flex align-items-center"
            onClick={() =>
              setState((prevState) => ({ ...prevState, isUpdate: true }))
            }
          >
            <Fi.FiEdit size={15} className="me-2" />
            Input Resi
          </button>
        )}

        {(data?.document_status === 'new' || data?.document_status === 'published') && (
          <>
            <Link
              className="dropdown-item d-flex align-items-center"
              role="button"
              to={`/receivable/update/${data?.id}`}
            >
              <Fi.FiEdit size={15} color="#202020" className="me-2" />
              Perbaharui
            </Link>
          </>
        )}

        {data?.document_status === 'new' && (
          <>
            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, isPublish: true }))
              }
            >
              <Fi.FiCheckCircle size={15} className="me-2" />
              Tagihkan
            </button>

            <button
              className="dropdown-item d-flex align-items-center"
              onClick={() =>
                setState((prevState) => ({ ...prevState, isDelete: true }))
              }
            >
              <Fi.FiTrash2 size={15} className="me-2" />
              Hapus
            </button>
          </>
        )}
      </DropdownButton>

      {/* modal delete */}
      <Modal
        show={isDelete}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-danger" />
          <Fi.FiAlertTriangle className="mb-2 text-danger" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Data yang sudah dihapus tidak bisa dipulihkan
          </p>

          {/* {isError ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {isError?.id}
            </div>
          ) : null} */}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="danger"
                className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handleDelete}
                disabled={StateLoading}
              >
                Hapus
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal publish */}
      <Modal
        show={isPublish}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Body>
          <div className="btn-close" onClick={$handleClose} />
          <div className="modal-status bg-primary" />
          <Fi.FiAlertTriangle className="mb-2 text-primary" size={90} />
          <h3>Anda yakin?</h3>
          <p className="text-danger fw-semibold">
            Dokumen ini akan ditagihkan ke customer
          </p>

          {/* {isError ? (
            <div className="invalid-feedback" style={{ display: 'block' }}>
              {isError?.id}
            </div>
          ) : null} */}
        </Modal.Body>
        <Modal.Footer>
          <div className="row w-100">
            <div className="col">
              <Button
                variant="white"
                className="w-100"
                onClick={$handleClose}
              >
                Batal
              </Button>
            </div>
            <div className="col">
              <Button
                variant="primary"
                className={StateLoading ? ' btn-loading w-100' : 'w-100'}
                onClick={$handlePublish}
                disabled={StateLoading}
              >
                Tagihkan
              </Button>
            </div>
          </div>
        </Modal.Footer>
      </Modal>

      {/* modal update */}
      <Modal
        show={isUpdate}
        onHide={$handleClose}
        backdrop="static"
        centered
        className="text-center"
        size="small"
      >
        <Modal.Header closeButton>
          <Modal.Title>Input Resi</Modal.Title>
        </Modal.Header>
        <FormPartial
          data={data}
          updateType='shipment_code'
          onClose={() => {
            $handleClose();
            Dispatch(Table.$reload('receivable', StateTable));
          }}
        />
      </Modal>
    </>
  );
}

export default Action;
